import { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Button, TextField, IconButton, CircularProgress, Chip, Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Autocomplete from '@mui/material/Autocomplete';
import { useDropzone } from 'react-dropzone';
import TagList from './TagList';
import { FILE_TYPE_LABELS, FILE_TYPES } from './MediaManagerComponent';
import { CloudUpload, Upload } from '@mui/icons-material';
import { APIData } from '../../constants/APIAdresses';
import { IMAGE_FILE_DIMENSIONS, resizeImage } from '../../components/Elements/ImageField';
const ERROR_MESSAGES = {
    NO_FILES: "Bitte wählen Sie mindestens eine Datei zum Hochladen aus.",
    GENERAL_ERROR: "Ein allgemeiner Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.",
}
export default function FileUploadDialog({ open, onClose, onUpload }) {
    const [type, setType] = useState('products');
    const [files, setFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [errorMsg, setErrorMsg] = useState(null);
    const [tagInput, setTagInput] = useState('');
    const [loading, setLoading] = useState(false);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop: (acceptedFiles) => {
            setFiles(acceptedFiles);
            if (errorMsg === ERROR_MESSAGES.NO_FILES) {
                setErrorMsg('');
            }
        },
    });

    const handleAddTag = (tag) => {
        setTags(prev => [...prev, tag.trim()]);
    };

    const handleDeleteTag = (idx, tag) => {
        setTags(prev => {
            const newTags = [...prev];
            newTags.splice(idx, 1); // remove tag at index
            return newTags;
        });
        // setTags(prev => prev.filter(t => t !== tag));
    };
    // const uploadImages = async (formData) => {
    //     try {
    //         const response = await fetch(`${APIData.MEDIA}/upload`, {
    //             method: 'POST',
    //             body: formData,
    //         });
    //         if (!response.ok) {
    //             throw new Error('Upload failed');
    //         }
    //         return await response.json();
    //     } catch (error) {
    //         console.error('Error uploading files:', error);
    //         throw error;
    //     }
    // }
    // const handleSubmit = async () => {
    //     if (!type || files.length === 0) return;
    //     setLoading(true);

    //     // build FormData
    //     const formData = new FormData();
    //     // formData.append('type', type);
    //     files.forEach(f => formData.append('files', f));
    //     tags.forEach(t => formData.append('tags', t));

    //     try {
    //         await onUpload(formData);
    //         handleCloseDialog(); // close dialog on success
    //     } catch (err) {
    //         console.error('Upload failed', err);
    //     } finally {
    //         setLoading(false);
    //     }
    // };
    const showError = (msg, duration) => {
        setErrorMsg(msg);
        setTimeout(() => {
            setErrorMsg('');
        }, duration);
    }
    const handleSubmit = async () => {
        console.log('Submitting files:', files, 'with type:', type, 'and tags:', tags);
        if (files.length === 0) {
            return setErrorMsg();
        }

        const formData = new FormData();

        for (const file of files) {
            formData.append('image', await resizeImage(file, IMAGE_FILE_DIMENSIONS[type].width, IMAGE_FILE_DIMENSIONS[type].height));
        }
        // formData.append('tags', 'example, tags, here');
        formData.append('tags', JSON.stringify(tags));

        setLoading(true);

        try {
            const res = await fetch(`${APIData.MEDIA}/upload?type=${type}`, {
                method: 'POST',
                body: formData,
                credentials: 'include',
            });

            const data = await res.json();

            if (!res.ok) {
                console.error(data);
                showError(ERROR_MESSAGES.GENERAL_ERROR, 5000);
            } else {
                onUpload?.(files, type, tags);
                resetContent();
            }
        } catch (err) {
            console.error(err);
            console.log("UPLOAD ERROR: ", err);
            showError(ERROR_MESSAGES.GENERAL_ERROR, 5000);
        } finally {
            setLoading(false);
        }
    };

    function resetContent() {
        setFiles([]);
        setTags([]);
        setErrorMsg(null);
        setType('products');
        setTagInput('');
        setLoading(false);
    }
    function handleCloseDialog() {
        onClose();
        resetContent();
    }
    return (
        <Dialog open={open} onClose={handleCloseDialog} fullWidth maxWidth="sm">
            <DialogTitle>
                Upload Files
                <IconButton onClick={handleCloseDialog} sx={{ position: 'absolute', right: 8, top: 8 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {/* Autocomplete */}
                {errorMsg?.length > 0 &&
                    <Typography sx={{ mb: 3, fontSize: "small" }} color='red'>{errorMsg}</Typography>
                }
                <Autocomplete
                    value={type}
                    onChange={(e, newValue) => setType(newValue)}
                    options={FILE_TYPES}
                    getOptionLabel={(option) => FILE_TYPE_LABELS[option] || option}
                    renderInput={(params) => <TextField {...params} label="Bildtyp auswählen" />}
                    sx={{ mb: 2 }}
                />
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2, fontSize: 10 }}>
                    Bitte wählen Sie den passenden Bildtyp für Ihren Upload aus.
                    Später werden nur die Bilder des gewählten Typs an den entsprechenden Stellen angezeigt.

                    Wird ein Bild als Produktbild hochgeladen, kann es nur für Produkte verwendet werden — nicht z. B. als Kategoriebild oder Titelbild.
                </Typography>
                {/* Drag & Drop */}
                <div
                    {...getRootProps()}
                    style={{
                        border: '2px dashed #ccc',
                        padding: 20,
                        textAlign: 'center',
                        cursor: 'pointer',
                        marginBottom: 16
                    }}
                >
                    <input {...getInputProps()} />
                    {isDragActive ? (
                        <p>Dateien hier ablegen …</p>
                    ) : (
                        <p>Dateien per Drag & Drop hierher ziehen oder klicken, um den Dateibrowser zu öffnen.</p>
                    )}
                </div>


                {/* Selected Files */}
                {files.length > 0 && (
                    <div style={{ marginBottom: 16 }}>
                        <strong>Dateien:</strong>
                        <ul>
                            {files.map((file, idx) => (
                                <li key={idx}>{file.name}</li>
                            ))}
                        </ul>
                    </div>
                )}


                <TagList onAddTag={(tag) => { handleAddTag(tag) }} offlineTags={tags} onDeleteTag={handleDeleteTag} fullWidth />
            </DialogContent>

            <DialogActions>
                <Button onClick={handleCloseDialog} disabled={loading}>Abbrechen</Button>
                <Button onClick={handleSubmit} startIcon={<CloudUpload />} variant="contained" disabled={loading || !type || files.length === 0}>
                    {loading ? <CircularProgress size={24} /> : 'Hochladen'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
